'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isRangeSelect(props) {
  return !!props.rangeSelect;
}

function isEmptyOrDate(props, propName) {
  var value = props[propName];

  if (!value) {
    return;
  }

  if (value instanceof Date && !isNaN(value)) {
    return;
  }

  return new Error('Invalid prop ' + propName + '. Must be a valid Date.');
}

exports.default = {
  rangeSelect: _propTypes2.default.bool,
  selectedDate: function selectedDate(props, propName) {
    if (isRangeSelect(props)) {
      return;
    }

    return isEmptyOrDate(props, propName);
  },
  selectedEndDate: function selectedEndDate(props, propName) {
    if (!isRangeSelect(props)) {
      return;
    }

    return isEmptyOrDate(props, propName);
  },
  selectedStartDate: function selectedStartDate(props, propName) {
    if (!isRangeSelect(props)) {
      return;
    }

    return isEmptyOrDate(props, propName);
  }
};